import { useCallback } from 'react';
import CandidatePickerItemPresenter from '../item/candidatePickerItemPresenter';
import { Actor, actorColorScheme, CandidatePositionNextStatus } from './candidatePositionNextStatusConfig';

export function getRowsByState(nextAction: CandidatePositionNextStatus) {
  if (!nextAction || !(nextAction in CandidatePositionNextStatus)) {
    return undefined;
  }

  const rawActor = nextAction.split('_')[0] as Actor;

  const isValidActor = Object.values(Actor).includes(rawActor);
  const actor = isValidActor ? rawActor : Actor.NONE;

  return {
    nextAction,
    actor,
    colorScheme: actorColorScheme[actor],
  };
}

export function useGetCandidatePositionNextStatus(candidate: CandidatePickerItemPresenter | null) {
  return useCallback(() => {
    const nextStatus = candidate?.candidate?.detailStatus?.next;

    if (!nextStatus) {
      return null;
    }

    return getRowsByState(nextStatus);
  }, [candidate]);
}
